import React, { FunctionComponent, useCallback } from 'react';
import {
  useFunnelState,
  useQuoteFlowDispatch,
} from 'scenes/common/contexts/quoteFlowContext';
import { useConfigActions } from 'scenes/common/hooks/useActions/useConfigActions';
import { useSystemConfig } from 'scenes/common/hooks/useSystemConfig';
import { StepDirection } from 'scenes/common/types';
import {
  OutageApiResponse,
  OutageFormAnswer,
  OutageProps,
  OutageState,
} from 'scenes/outage/types';

export const withOutage = (
  Component: FunctionComponent<OutageProps>
): FunctionComponent => () => {
  const funnelState = useFunnelState<OutageState>();
  const dispatch = useQuoteFlowDispatch();

  const handleAnswer = useCallback(
    (answer: OutageFormAnswer) => {
      // Enable this if you need to debug actions
      // console.log('handleAnswer Received', { answer, step: funnelState.step });
      dispatch({ ...answer, sourceStep: funnelState.step });
    },
    [dispatch, funnelState.step]
  );

  const apiResponse = (
    apiResponses: Partial<OutageApiResponse>
  ): OutageFormAnswer => ({
    direction: StepDirection.ApiResponse,
    formValues: {},
    apiResponses,
  });

  const onApiResponse = useCallback(
    (response: Partial<OutageApiResponse>) => {
      handleAnswer(apiResponse(response));
    },
    [handleAnswer]
  );

  const { onGetConfig } = useConfigActions(onApiResponse);
  // Enable maintenance page
  useSystemConfig(onGetConfig);

  return <Component funnelState={funnelState} />;
};

export default withOutage;
